import Routes from '../routes.mjs';
import redirectToDomain from './redirectToDomain';

export const getTargetOrigin = (
  sourceOrigin,
  targetOriginSuffix = 'fashionunited.com',
) => sourceOrigin
  .replace(/https?:\/\/localhost(:\d+)?/, 'https://local.fashionunited.ie')
  .replace(
    // eslint-disable-next-line @stylistic/max-len
    /(-(ae|au|az|bd|bg|bo|ci|cn|cr|cy|do|dz|ec|ee|eg|ge|gh|gr|gt|hn|hr|id|il|jo|ke|kh|kr|kz|lb|lk|lt|lv|ma|mg|mt|my|ng|np|pa|ph|pk|pr|py|ro|rs|ru|sa|sg|si|sk|sn|sv|th|tn|tw|ua|uy|uz|ve|vn|za|dashboard)(\.))?((ae|au|az|bd|bg|bo|ci|cn|cr|cy|do|dz|ec|ee|eg|ge|gh|gr|gt|hn|hr|id|il|jo|ke|kh|kr|kz|lb|lk|lt|lv|ma|mg|mt|my|ng|np|pa|ph|pk|pr|py|ro|rs|ru|sa|sg|si|sk|sn|sv|th|tn|tw|ua|uy|uz|ve|vn|za|dashboard)\.)?[^./]+\.((com\.[^.:]+)|([^.:]+))($|(?=:))/,
    `$3${targetOriginSuffix}`,
  )
  .replace(/\/\/([^./]+)\.([^./]+)\.([^./]+)\./, '//$1-$2.$3.')
  .replace(
    // eslint-disable-next-line @stylistic/max-len
    /\/\/review-([^.]+?)((-pwa)?(-(ae|au|az|bd|bg|bo|ci|cn|cr|cy|do|dz|ec|ee|eg|ge|gh|gr|gt|hn|hr|id|il|jo|ke|kh|kr|kz|lb|lk|lt|lv|ma|mg|mt|my|ng|np|pa|ph|pk|pr|py|ro|rs|ru|sa|sg|si|sk|sn|sv|th|tn|tw|ua|uy|uz|ve|vn|za))?)?\./,
    '//review-$1-pwa$4.',
  );

const getPortServer = (request) => {
  if (request.get('x-forwarded-port')) {
    return `:${request.get('x-forwarded-port')}`;
  }

  return '';
};

const getPortBrowser = () => {
  if (window.location.port) {
    return `:${window.location.port}`;
  }
  return '';
};

const redirectRouteToDomain = (
  route,
  exceptions = [],
  statusCode = 301,
) => (
  { req, res, query },
) => {
  // eslint-disable-next-line no-underscore-dangle
  const locale = req ? req.locale : window.__NEXT_DATA__.props.locale;
  const path = Routes.findAndGetUrls(route, query).urls.as;

  const hostname = req ? req.get('host') : window.location.hostname;
  const port = req ? getPortServer(req) : getPortBrowser();
  const origin = `https://${hostname}${port}`;
  const targetOrigin = getTargetOrigin(origin);

  if (
    ![...exceptions, 'en-US'].includes(locale)
    && hostname !== 'localhost'
  ) redirectToDomain(path, res, targetOrigin, statusCode);
  return {};
};

export default redirectRouteToDomain;
